export const colourSchemeKey = 'colour scheme';
